"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
exports.default = react_1.forwardRef(function TextField(_a, ref) {
    var _b;
    var label = _a.label, onEnter = _a.onEnter, _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? true : _d, onKeyPress = _a.onKeyPress, classes = _a.classes, _e = _a.hiddenLabel, hiddenLabel = _e === void 0 ? Boolean(label) === false : _e, _f = _a.square, square = _f === void 0 ? false : _f, _g = _a.disableUnderline, disableUnderline = _g === void 0 ? variant === 'filled' : _g, rest = __rest(_a, ["label", "onEnter", "variant", "fullWidth", "onKeyPress", "classes", "hiddenLabel", "square", "disableUnderline"]);
    var internalClasses = useStyles();
    var handleKeyPress = function (event) {
        onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(event);
        if (event.key === 'Enter' && onEnter !== undefined) {
            onEnter(event, event.target.value);
        }
    };
    if (disableUnderline) {
        rest.InputProps = __assign({ disableUnderline: disableUnderline }, rest.InputProps);
    }
    return (jsx_runtime_1.jsx(TextField_1.default, __assign({ classes: __assign({
            root: classnames_1.default((_b = {},
                _b[internalClasses.squareRoot] = square,
                _b[internalClasses.filled] = variant === 'filled',
                _b)),
        }, classes), variant: variant, fullWidth: fullWidth, onKeyPress: handleKeyPress, label: label, hiddenLabel: hiddenLabel }, rest, { ref: ref }), void 0));
});
var useStyles = core_1.makeStyles(function (theme) { return ({
    squareRoot: {
        '& .MuiInputBase-root': {
            borderRadius: 0,
        },
    },
    filled: {
        '& > .MuiInputBase-root': {
            borderRadius: theme.shape.borderRadius + "px",
        },
        '& .MuiFilledInput-inputHiddenLabel.MuiFilledInput-inputMarginDense': {
            paddingTop: 14,
            paddingBottom: 15,
        },
    },
}); });
//# sourceMappingURL=TextField.js.map